<template>
  <div class="product">
    <div
      class="product-image"
      :style="{ backgroundImage: `url(${getImageUrl()})` }"
    ></div>
    <div class="product-details" v-if="product">
      <div class="product-name">{{ product.title }}</div>
      <div class="product-subtitle">{{ product.subtitle }}</div>
    </div>
  </div>
</template>

<script>
import ServiceManager from "../services/service-manager";

export default {
  name: "ProductCard",
  components: {},
  props: ["product"],
  data() {
    return {
      labels: ServiceManager.getService(this, "Labels"),
      config: ServiceManager.getService(this, "Config"),
    };
  },
  methods: {
    getImageUrl() {
      let url = this.config.defaultProductImage;
      if (this.product && this.product.imageUrl) {
        url = this.product.imageUrl;
      }
      return url;
    },
  },
};
</script>

<style scoped>
.product {
  display: flex;
  align-items: center;
}

.product-image {
  width: 60px;
  height: 60px;
  min-width: 60px;
  background-size: cover;
  background-repeat: no-repeat;
  margin-right: 20px;
}

.product-name {
  font-size: 14px;
  font-weight: 700;
}

.product-subtitle {
  font-size: 14px;
  font-weight: 300;
}

.product-description {
}
</style>